// import PopupMenu from "../PopupMenu/PopupMenu";
// import arrowDownGolden from "../../assets/images/svg/arrowDownGolden.svg";
import { useState, useEffect, useRef } from "react";
// import { analyticsCategories } from "../../utils/constants";
import RadioGroup from "../Reports/RadioGroup";
// import { getPortfolioAssetClasses } from "../../api/hooks/overall";
import { observer } from "mobx-react";
import UserStore from "../../store/UserStore";
// import AnalyticsStore from "../../store/AnalyticsStore";
// import { timePeriodBillsData } from "../../utils/constants";
// import FilledButton from "../SelectButton/FilledButton";
// import EmptyButton from "../SelectButton/EmptyButton";
//import Dropdown from "../Analytics/Equity/Dopdown/Dropdown";
import { setCookie, getCookie } from "../../utils/cookie";
import RadioDropdown from "../Analytics/Equity/Dopdown/RadioDropdown";

// const dd = [
//   {
//     clientcode: "1",
//     id: 2,
//     name: "Equity",
//     defaultIndex: {
//       clientcode: "1",
//       id: 3,
//       name: "CNX 50 TRI",
//     },
//   },
//   {
//     clientcode: "1",
//     id: 3,
//     name: "Hybrid/Others",
//     defaultIndex: {
//       clientcode: "1",
//       id: 3,
//       name: "CNX 50 TRI",
//     },
//   },
//   {
//     clientcode: "1",
//     id: 4,
//     name: "Fixed Income",
//     defaultIndex: {
//       clientcode: "1",
//       id: 5,
//       name: "Crisil Bond",
//     },
//   },
//   {
//     clientcode: "1",
//     id: 5,
//     name: "Alternatives",
//     defaultIndex: {
//       clientcode: "1",
//       id: 3,
//       name: "CNX 50 TRI",
//     },
//   },
//   {
//     clientcode: "1",
//     id: 6,
//     name: "DERIVATIVES",
//     defaultIndex: {
//       clientcode: "1",
//       id: 3,
//       name: "CNX 50 TRI",
//     },
//   },
// ];

const BestWorstPerformer = observer(
  ({
    setPerformanceOption,
    dropdownItems,
    selectedItem,
    onChangeSelectedItem,
    onChangeRadioBtn,
    selectedRadioBtn,
    isData = true,
    loading = false,
  }) => {
    const [categoriesMenuOpen, setCategoriesMenuOpen] = useState(false);
    const dropdownButtonRef = useRef(null);
    const dropdownContainerRef = useRef(null);

    // const [categoriesTitle, setcategoriesTitle] =
    //   useState("Across categories");
    // const [switchReturns, setSwitchReturns] = useState("IRR");

    useEffect(() => {
      let familyId = UserStore?.userData?.family_id;
      if (familyId) {
        setCookie("familyId", familyId);
      } else {
        familyId = getCookie("familyId");
      }
    }, []);

    function toTitleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }

    const updatedDropdownItems = dropdownItems.map((menuItem) => {
      if (menuItem.id === 18 || menuItem.id === 55 || menuItem.id === 3) {
        return {
          ...menuItem,
          name: menuItem.name,
        };
      } else {
        return {
          ...menuItem,
          name: toTitleCase(menuItem.name),
        };
      }
    });

    // const handleSwitchReturns = (selectedSwitch) => {
    //   setSwitchReturns(selectedSwitch);
    // };

    // const AnalyticsProfileMenuContent = () => {
    //   // const handleClickOnAnalyticscategoriesOption = (id, name) => {
    //   //   setCategoriesMenuOpen(false);
    //   //   setcategoriesTitle(name);
    //   //   setPerformanceOption(id);
    //   // };

    //   return (
    //     <ul
    //       className="portfolio_report_accounts_container"
    //       style={{
    //         padding: "20px 28px 16px 20px",
    //         alignSelf: "center",
    //       }}
    //     >
    //       {dropdownItems?.map((menuItem) => {
    //         return (
    //           <li
    //             className="account_listitem"
    //             key={menuItem?.id}
    //             onClick={() => {
    //               // handleClickOnAnalyticscategoriesOption(
    //               //   menuItem?.id,
    //               //   menuItem.name
    //               // )
    //               onChangeSelectedItem(menuItem);
    //               setCategoriesMenuOpen(false);
    //             }}
    //           >
    //             <div className="radio_btn_input">
    //               {menuItem?.name === selectedItem?.name ? (
    //                 <FilledButton />
    //               ) : (
    //                 <EmptyButton />
    //               )}
    //             </div>
    //             <label className="radio_btn_label" for={menuItem?.name}>
    //               {menuItem.id === 18 || menuItem.id === 55 || menuItem.id === 3
    //                 ? menuItem.name
    //                 : toTitleCase(menuItem.name)
    //               }
    //             </label>
    //             {/* <p className="listitem_text">{menuItem?.name}</p> */}
    //           </li>
    //         );
    //       })}
    //     </ul>
    //   );
    // };

    return (
      <>
        <div className="best__worst__section" style={{ marginBottom: "23px" }}>
          <div>
            {isData && (
              <div className="equity-card-title">
                Best and Worst <b>Performers</b>
              </div>
            )}
          </div>
          {isData && (
            <div className="categories__section">
              <div className="categores__div__section">
                <p
                  className="show_me"
                  style={{
                    width: 80,
                    fontFamily: "Encode Sans",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Show me
                </p>
                <div
                  className="categories__dropdown"
                  style={{ borderWidth: 0 }}
                  // style={{ marginRight: 20, width: 230 }}
                >
                  {/* <Dropdown
                    selected={selectedItem}
                    open={categoriesMenuOpen}
                    setOpen={setCategoriesMenuOpen}
                    position={{ top: "56px", right: 0, left: 0 }}
                    items={updatedDropdownItems}
                    handleChange={(selectedOption) => {
                      onChangeSelectedItem(selectedOption);
                    }}
                    valuePropertyName="id"
                    labelPropertyName="name"
                  /> */}

                  <RadioDropdown
                    selected={selectedItem}
                    open={categoriesMenuOpen}
                    setOpen={setCategoriesMenuOpen}
                    position={{ top: "56px", right: 0, left: 0 }}
                    items={updatedDropdownItems}
                    handleChange={(selectedOption) => {
                      onChangeSelectedItem(selectedOption);
                    }}
                    valuePropertyName="id"
                    labelPropertyName="name"
                    containerRef={dropdownContainerRef}
                    ref={dropdownButtonRef}
                  />
                </div>
              </div>
              <div className="categores__div__section">
                <p className="switch_returns" style={{ fontSize: "14px" }}>
                  Switch returns to
                </p>
                <div className="switch__radio__group">
                  <RadioGroup
                    heading=""
                    name=""
                    radioBtnArray={[
                      { title: "IRR", value: "irr" },
                      { title: "Absolute", value: "abs_val" },
                    ]}
                    handleChange={(val) => onChangeRadioBtn(val)}
                    value={selectedRadioBtn}
                    radioBtnsPerRow={2}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
);

export default BestWorstPerformer;
